import { QueryKey } from '@tanstack/react-query';
import { Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import { Integration } from 'models/InternalIntegrationSetting';
import { IntegrationMutationLevel } from 'pages/integrations/hooks/useDisableIntegrationMutation';
import useEnableIntegrationMutation from 'pages/integrations/hooks/useEnableIntegrationMutation';
import useRedirectToIntegrationDetails from 'pages/integrations/hooks/useRedirectToIntegrationDetails';

const useReenrollHostfullyAssistModal = () => {
  const { t } = useTranslation();
  const { openConfirmModal } = useAppModal();
  const { enableIntegration } = useEnableIntegrationMutation();
  const { redirectToIntegrationDetails } = useRedirectToIntegrationDetails();

  const openReenrollHostfullyAssistModal = ({
    integration,
    queryKey,
  }: {
    integration: Integration;
    queryKey: QueryKey;
  }) => {
    const handleConfirmReenroll = () => {
      enableIntegration(
        {
          level: IntegrationMutationLevel.AGENCY,
          enumId: integration.enumId,
          queryKey,
        },
        {
          onSuccess: () => {
            redirectToIntegrationDetails(integration);
          },
        },
      );
    };

    openConfirmModal({
      title: t('pageIntegrations.modals.reenrollHostfullyAssist.title'),
      body: (
        <Alert bsStyle="danger">
          {t('pageIntegrations.modals.reenrollHostfullyAssist.warning')}
        </Alert>
      ),
      confirmLabel: t(
        'pageIntegrations.modals.reenrollHostfullyAssist.confirmBtn',
      ),
      cancelLabel: t('common.cancel'),
      onConfirm: handleConfirmReenroll,
    });
  };

  return { openReenrollHostfullyAssistModal };
};

export default useReenrollHostfullyAssistModal;
